// @flow
import env from '../../../environment';
import {
  postCreator,
  getCreator,
  deleteCreator,
  putCreator,
} from '../../../http';

export const endpoints = Object.freeze({
  CREATE_BANNER_COLLECTION: `${env.baseApiUrl}/ui/admin/collection`,
  GET_BANNER_COLLECTION: `${env.baseApiUrl}/ui/admin/collection/:collectionId`,
  UPDATE_BANNER_COLLECTION: `${env.baseApiUrl}/ui/admin/collection/:collectionId`,
  DELETE_BANNER_COLLECTION: `${env.baseApiUrl}/ui/admin/collection/:collectionId`,
});

export const getBannerCollectionApi = getCreator(
  endpoints.GET_BANNER_COLLECTION
);

export const deleteBannerCollectionApi = deleteCreator(
  endpoints.DELETE_BANNER_COLLECTION
);

export const updateBannerCollectionApi = putCreator(
  endpoints.UPDATE_BANNER_COLLECTION
);

export const createBannerCollectionApi = postCreator(
  endpoints.CREATE_BANNER_COLLECTION
);
